const statusesOf = (config) =>
  (config && (config.statuses || config.processStatuses)) || [];

const fieldsOf = (status) =>
  (status.formDefinition && status.formDefinition.fields) ||
  status.fields ||
  [];

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const selectedPlanOptions = (config) => {
  const options = [];
  for (const status of statusesOf(config)) {
    for (const field of fieldsOf(status)) {
      if (field.accessor !== "fields.selectedPlan") continue;
      for (const option of field.options || []) {
        if (!option || !option.value || !option.label) continue;
        options.push({
          label: String(option.label),
          value: String(option.value),
        });
      }
    }
  }
  return options;
};

export const planIdMap = (options, plans) => {
  const knownIds = new Set((plans || []).map((plan) => plan.id));
  const map = {};
  for (const option of options || []) {
    if (knownIds.has(option.value) || map[option.value]) continue;
    const label = normalize(option.label);
    if (!label) continue;
    const matches = (plans || []).filter(
      (plan) =>
        normalize(plan.alias) === label || normalize(plan.name) === label,
    );
    if (matches.length !== 1) continue;
    map[option.value] = matches[0].id;
  }
  return map;
};

const replaceIds = (text, entries) =>
  entries.reduce((current, [from, to]) => current.split(from).join(to), text);

export const rewritePlanIds = (value, idMap) => {
  const entries = Object.entries(idMap || {}).filter(
    ([from, to]) => from && to && from !== to,
  );
  if (!entries.length) return value;
  const visit = (item) => {
    if (typeof item === "string") return replaceIds(item, entries);
    if (Array.isArray(item)) return item.map(visit);
    if (!item || typeof item !== "object") return item;
    return Object.keys(item).reduce((copy, key) => {
      copy[replaceIds(key, entries)] = visit(item[key]);
      return copy;
    }, {});
  };
  return visit(value);
};

export const remapImportedPlanIds = (config, plans) =>
  rewritePlanIds(config, planIdMap(selectedPlanOptions(config), plans));
